import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { CustomerPermission } from "app/_models/customerpermission";
import { Observable } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { EnvironmentService } from "./index";

@Injectable()
export class CustomerPermissionService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private environmentService: EnvironmentService,
    private authenticationService: AuthenticationService) {
  }

  getAll(): Observable<CustomerPermission[]> {
    let customerPermissions = this.http
      .get(`${this.baseUrl}/customerpermissions`, this.makeHeaders())
      .map(mapCustomerPermissions)
      .catch(handleError);
    return customerPermissions;
  }

  getAllForDealer(dealerId: string): Observable<CustomerPermission[]> {
    let customerPermissions = this.http
      .get(`${this.baseUrl}/customerpermissions?dealer=${dealerId}&populate=customer`, this.makeHeaders())
      .map(mapCustomerPermissions)
      .catch(handleError);
    return customerPermissions;
  }

  get(id: string): Observable<CustomerPermission> {
    let customerPermission = this.http
      .get(`${this.baseUrl}/customerpermissions/${id}`, this.makeHeaders())
      .map(mapCustomerPermission);
    return customerPermission;
  }

  save(customerPermission: CustomerPermission): Observable<Response> {
    return this.http
      .put(`${this.baseUrl}/customerpermissions/${customerPermission._id}`, JSON.stringify(customerPermission), this.makeHeaders());
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json');
    headers.append('charset', 'UTF-8');
    headers.append('Accept', 'application/json');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function mapCustomerPermissions(response: Response): CustomerPermission[] {
  return response.json().map(toCustomerPermission);
}

function mapCustomerPermission(response: Response): CustomerPermission {
  return toCustomerPermission(response.json());
}

function toCustomerPermission(r: any): CustomerPermission {
  let customerPermission = <CustomerPermission>({
    _id: r._id,
    customer: r.customer,
    answer: r.answer,
    mauticId: r.mauticId,
    date: r.date,
    handled: r.handled
  });

  return customerPermission;
}

function handleError (error: any) {
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}


// WEBPACK FOOTER //
// ./src/app/_services/customerpermissions.service.ts